<mat-form-field>
    <mat-label>{{ model.additional!['LABEL'] }}</mat-label>
    <input matInput [type]="'number'" [value]="value" [readonly]="model.readOnly" autocomplete="off" (keyup)="onInputChanged($event)">
</mat-form-field>